export const genderData = [
  { value: "Male", label: "Male" },
  { value: "Female", label: "Female" },
];
